import * as t from 'io-ts'

import extractIoTsErrorsWithPath from './extract-io-ts-errors-with-path'

const formatIoTsErrors = (topObjectName: string, errors: t.Errors): string => {
  const ioTsErrors = extractIoTsErrorsWithPath(topObjectName, errors)
  const formattedMessages = ioTsErrors.map(
    ({ path, found, expected }) =>
      `${path}:
  found: ${found}
  expected: ${expected}
`,
  )
  formattedMessages.sort()
  return formattedMessages.join('\n')
}

export default formatIoTsErrors
